import React, { useState } from "react";
import { useSubscribe } from "react-pwa-push-notifications";
import { saveSubscription } from "../services/firestoreService"; // Stelle sicher, dass die Funktion korrekt importiert wird!
import { Button } from "@mui/material";

const PushNotificationButton = () => {
  const { getSubscription } = useSubscribe({
    publicKey: "BDjuKOBn9YZeX28aYtXJ2vXRpWpXBTv1w3NknRkwjKGujtENcMWDUfuHwGg_XNZUmhox6GUOXw1NNWzHyq6RCa8",
  });

  const [subscribed, setSubscribed] = useState(false);

  const handleSubscribe = async () => {
    try {
      const subscription = await getSubscription();
      console.log("🔔 Push Subscription erfolgreich:", subscription);
      
      await saveSubscription(subscription); // Speichert das Abo in Firestore
      setSubscribed(true);
    } catch (err) {
      console.error("❌ Fehler beim Abonnieren:", err);
    }
  };

  return (
    <Button onClick={handleSubscribe}>
      {subscribed ? "✅ Benachrichtigungen aktiviert" : "🔔 Push aktivieren"}
    </Button>
  );
};

export default PushNotificationButton;
